import React from "react";
import { Stack, ToggleButton, ToggleButtonGroup, Typography, Paper } from "@mui/material";
import { useLocale } from "../../context/LocaleContext";

export default function TransactionSelector({ transaction, setTransaction }) {
	const { messages } = useLocale();
	const handleChange = (event, newTransaction) => {
		if (newTransaction !== null) {
			setTransaction(newTransaction)
		}
	}
	return (
		<ToggleButtonGroup
			value={transaction}
			exclusive
			onChange={handleChange}
			fullWidth
			sx={{ marginTop: "10px", marginBottom: "10px" }}
		>
			<Paper elevation={3} sx={{ width: "100%", flexDirection: "row", display: "flex" }}>
				<ToggleButton value="sale">
					<Stack flexDirection="row" justifyContent="center" alignItems="center">
						<Typography fontSize="13px">{messages.barcode.sale}</Typography>
					</Stack>
				</ToggleButton>
				<ToggleButton value="purchase">
					<Stack flexDirection="row" justifyContent="center" alignItems="center">
						<Typography fontSize="13px">{messages.barcode.purchase}</Typography>
					</Stack>
				</ToggleButton>
				<ToggleButton value="return">
					<Stack flexDirection="row" justifyContent="center" alignItems="center">
						<Typography fontSize="13px">{messages.barcode.return}</Typography>
					</Stack>
				</ToggleButton>
			</Paper>
		</ToggleButtonGroup >
	);
}